var _path, _g, _path2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctornowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_521_2577",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.93311 0.933838H26.1454V19.1908H7.93311V0.933838Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_521_2577)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0058 8.86811H18.2127V6.08584C18.2127 3.2401 15.9111 0.933838 13.0724 0.933838C10.2346 0.933838 7.93311 3.2401 7.93311 6.08584V14.0388C7.93311 16.8836 10.2346 19.1908 13.0724 19.1908C13.1041 19.1908 13.1283 19.174 13.159 19.173H21.0058C23.8445 19.173 26.146 16.8658 26.146 14.021C26.146 11.1753 23.8445 8.86811 21.0058 8.86811Z",
    fill: "#FF8D00",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_521_2577",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 8,
    width: 19,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.83423H18.2129V27.0915H0V8.83423Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_521_2577)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0727 8.83423C13.0419 8.83423 13.0159 8.85103 12.9861 8.85196H5.13931C2.30152 8.85196 0 11.1582 0 14.004C0 16.8497 2.30152 19.1569 5.13931 19.1569H7.93241V21.9392C7.93241 24.784 10.2339 27.0921 13.0727 27.0921C15.9114 27.0921 18.2129 24.784 18.2129 21.9392V13.9872C18.2129 11.1405 15.9114 8.83423 13.0727 8.83423Z",
    fill: "#FF8D00"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctornowIcon);
export default __webpack_public_path__ + "static/media/doctornowIcon.16d6db6b07839604bafd2ab19b04ab30.svg";
export { ForwardRef as ReactComponent };